import { glom } from '../Signage/glom';
import { TimelineSlot, Widget, WidgetType } from '../Widget';
import { interleave, TimelineBase } from './TimelineBase';

export class Timeline extends TimelineBase {
    /**
     * Time in seconds saved up from leftover time
     */
    private pooledTime: number;

    /**
     * Length of time in loop
     */
    private loopLength: number;

    constructor(loopLength = 60) {
        super();
        this.loopLength = loopLength;
        this.pooledTime = 0;
    }

    public abortLoop(): void {
        this.pooledTime = 0;
        super.abortLoop();
    }

    /**
     * @inheritDoc
     * @todo: Review: override logic seems wrong, bad
     */
    protected buildTimelineLoop(): TimelineSlot[] {
        //make clone of widgets so original timeline widgets do not get removed
        let widgets: Widget[] = this.timelineWidgets.slice();
        const overrideWidget = this.getOverrideWidget(widgets);

        widgets = this.filterWidgets(widgets, overrideWidget);

        let slots: TimelineSlot[] = [];
        let currentSlots: TimelineSlot[] = [];
        let timeRemaining: number = this.loopLength + this.pooledTime;
        let lastWidgetType: WidgetType | null = null;
        widgets.forEach((widget) => {
            let numSlots = 0;

            if (widget.filler) {
                numSlots = 100000000; //set numSlots to some arbitrarily large value
            } else if (null !== widget.saturation) {
                numSlots = widget.saturation;
            }

            if (numSlots > glom.maxLoopSlots) {
                numSlots = glom.maxLoopSlots;
            }

            if (null != lastWidgetType && lastWidgetType != widget.type) {
                slots = interleave(slots, currentSlots);
                currentSlots = [];
            }

            const slotsRequired: TimelineSlot[] = widget.querySlots(numSlots, timeRemaining);
            if (slotsRequired.length > 0) {
                currentSlots = interleave(currentSlots, slotsRequired);

                let minimumTimeRemaining = 0;
                slotsRequired.forEach((slot) => {
                    //we never want time remaining to be less than any slot duration
                    minimumTimeRemaining =
                        slot.duration > minimumTimeRemaining ? slot.duration : minimumTimeRemaining;
                    const timeMinusSlotDuration = timeRemaining - slot.duration;

                    if (timeMinusSlotDuration < minimumTimeRemaining) {
                        timeRemaining = minimumTimeRemaining;
                    } else {
                        timeRemaining = timeMinusSlotDuration;
                    }
                });
            }

            lastWidgetType = widget.type;
        });

        this.pooledTime = timeRemaining;

        return interleave(slots, currentSlots);
    }
}
